/**
 * 判断当前是否为移动端（用于协议活体：手机直做 / PC 扫码）
 */
export function isMobileDevice() {
  if (typeof navigator === 'undefined') return false
  const ua = navigator.userAgent || ''
  return /Android|webOS|iPhone|iPod|BlackBerry|iPad|iOS|Mobile/i.test(ua)
}

/**
 * 加载阿里云金融级实人认证 MetaInfo（H5）
 * 文档：需在实际做活体的浏览器中采集
 */
export function loadAliyunMetaInfo() {
  return new Promise((resolve, reject) => {
    const exist = (window as any).getMetaInfo
    if (typeof exist === 'function') {
      try {
        resolve(exist())
        return
      } catch (e) {
        reject(e)
        return
      }
    }
    const script = document.createElement('script')
    script.src = 'https://o.alicdn.com/yd-cloudauth/cloudauth-cdn/jsvm_all.js'
    script.async = true
    script.onload = () => {
      const fn = (window as any).getMetaInfo
      if (typeof fn !== 'function') {
        reject(new Error('阿里云实人认证 SDK 加载失败'))
        return
      }
      try {
        resolve(fn())
      } catch (e) {
        reject(e)
      }
    }
    script.onerror = () => reject(new Error('阿里云实人认证 SDK 脚本加载失败'))
    document.head.appendChild(script)
  })
}
